import React from 'react';

function Map() {
  return (
    <section className="tc-map-style1">
      <div className="map-card wow zoomIn slow" data-wow-delay="0.2s">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d355.32000741761846!2d30.97721779717484!3d29.997253043230348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458574819aac31b%3A0x3658cb21e6d37fb!2sXXWG%2BVX8%2C%20First%206th%20of%20October%2C%20Giza%20Governorate%203237030!5e0!3m2!1sen!2seg!4v1731524799730!5m2!1sen!2seg"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
        loading="lazy" referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}

export default Map;
{/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d355.32000741761846!2d30.97721779717484!3d29.997253043230348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458574819aac31b%3A0x3658cb21e6d37fb!2sXXWG%2BVX8%2C%20First%206th%20of%20October%2C%20Giza%20Governorate%203237030!5e0!3m2!1sen!2seg!4v1731524799730!5m2!1sen!2seg" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}